export const routes = {
  login: "/",
  dashboard: "/dashboard",
  changePassword: "/changePassword",
  forgotPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
  dispatchTimer: "/timer",
  marketing: "/marketing",
  merchants: "/merchants",
  payments: "/payments",
  summary: "/summary",
  settings: "/settings",
  thirdParty:"/thirdParty",
  acceptPriceChange: "acceptPriceChange",
  sportsShopOnBoard: "onboarding"
};
